import { render, staticRenderFns } from "./dialog-preview-sharedwithme.vue?vue&type=template&id=7c0e5d4a&scoped=true&"
import script from "./dialog-preview-sharedwithme.vue?vue&type=script&lang=js&"
export * from "./dialog-preview-sharedwithme.vue?vue&type=script&lang=js&"
import style0 from "./dialog-preview-sharedwithme.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dialog-preview-sharedwithme.vue?vue&type=style&index=1&id=7c0e5d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0e5d4a",
  null
  
)

export default component.exports